import React, { FC } from 'react';

import Timer from '../Timer/Timer';
import classes from './AgentTicket.module.scss';
import { AgentsTicketType, TicketCommentsType } from '../../../pagesMain/Agent1Page/Agent1Page';
import { format } from 'date-fns';
import classNames from 'classnames';

type TicketPropsType = {
  agentStatus: string;
  timeToRequest: number | null;
  ticket: AgentsTicketType;
  comments: TicketCommentsType;
  benefitTicketColor?: string;
  otoTicketColor?: string;
};

const DEFAULT_BENEFIT_COLOR = '#cfe2ff';
const DEFAULT_OTO_COLOR = '#f8d7da';

const resolvePrivilegeKind = (ticket: AgentsTicketType): 'BENEFIT' | 'EMERGENCY' | null => {
  if (ticket.privilegeKind === 'EMERGENCY' || ticket.privilegeKind === 'BENEFIT') {
    return ticket.privilegeKind;
  }
  const priority = ticket.priority ?? 0;
  if (priority >= 20) {
    return 'EMERGENCY';
  }
  if (priority > 0) {
    return 'BENEFIT';
  }
  return null;
};

const AgentTicket: FC<TicketPropsType> = ({
  ticket,
  timeToRequest,
  agentStatus,
  comments,
  benefitTicketColor = DEFAULT_BENEFIT_COLOR,
  otoTicketColor = DEFAULT_OTO_COLOR
}) => {
  const { name, dateTime, topicName, extraData } = ticket;
  const privilegeKind = resolvePrivilegeKind(ticket);
  const highlightColor =
    privilegeKind === 'EMERGENCY'
      ? otoTicketColor
      : privilegeKind === 'BENEFIT'
        ? benefitTicketColor
        : undefined;

  return (
    <div
      className={classNames(classes.container, {
        [classes.highlighted]: Boolean(highlightColor)
      })}
      style={highlightColor ? { backgroundColor: highlightColor } : undefined}>
      <div className={classes.ticketName}>Билет {name}</div>
      <div className={classes.timeContainer}>
        <div>
          <div className={classes.titleInfo}>Талон взят</div>
          <span className={classes.textInfo}>{format(dateTime, 'HH:mm')}</span>
        </div>
        <div className={classes.request}>
          <div className={classes.titleInfo}>Вызван</div>
          <span className={classes.textInfo}>
            {timeToRequest && format(timeToRequest, 'HH:mm')}
          </span>
        </div>
      </div>
      <div className={classes.service}>
        <div className={classes.titleInfo}>Услуга</div>
        <span className={classes.textInfo}>{topicName}</span>
      </div>
      {extraData ? (
        <div className={classes.extraData}>
          <div className={classes.titleInfo}>Дополнительные данные</div>
          <span className={classes.textInfo}>{extraData}</span>
        </div>
      ) : null}
      <div className={classes.comment}>
        <div className={classes.titleInfo}>Комментарий</div>
        <div className={classes.commentContainer}>
          {comments
            ? comments.map((comment: string, index: number) => (
                <div key={index} className={classes.textInfo}>
                  {comment}
                </div>
              ))
            : null}
        </div>
      </div>
      <div className={classes.titleInfo}>В работе</div>
      <div>
        <Timer
          agentStatus={agentStatus}
          className={classes.timerInfo}
        />
        <span className={classes.seconds}>сек.</span>
      </div>
    </div>
  );
};

export default AgentTicket;
